(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beedo-editorial"] && !Shopify.designMode) return;
  try {
    
  function activateBeedoArticleLinks() {
    document.querySelectorAll('[data-beedo-product-url]').forEach((content) => {
      const url = content.dataset.beedoProductUrl;
      content.querySelectorAll('span[data-link-pending="true"]').forEach((placeholder) => {
        const link = document.createElement('a');
        link.href = url;
        link.dataset.beedoCta = 'true';
        link.style.cssText = placeholder.style.cssText;
        link.style.cursor = 'pointer';
        link.replaceChildren(...placeholder.childNodes);
        placeholder.replaceWith(link);
      });
    });
  }
  activateBeedoArticleLinks();
  document.addEventListener('shopify:section:load', activateBeedoArticleLinks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
